// Empty state for either half of the comparison grid, so a missing
// reference image and a missing detection render identically.
export function Placeholder({ text }: { text: string }) {
  return (
    <div className="bg-onlight-bg-2 dark:bg-ondark-bg-2 text-onlight-text-2 dark:text-ondark-text-2 flex h-full w-full items-center justify-center p-4 text-center text-sm">
      {text}
    </div>
  );
}

export default Placeholder;
